import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

declare let Stripe: any;

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  constructor(private http: HttpClient) {}

  checkout(
    pricingPlanIds: string[],
    vetCode?: string,
    chipNumber?: string,
    petId?: number
  ): Observable<any> {

    return new Observable((subscriber) => {
      this.http
        .post<any>(
          `${environment.apiUrl}/api/stripe/session`,
          {
            vetCode: vetCode ? vetCode : null,
            chipNumber: chipNumber ? chipNumber : null,
            petId: petId ? petId : null,
            PriceIds: pricingPlanIds,
          }
        )
        .subscribe(
          (paymentSessionId) => {
            const stripe = Stripe(environment.stripeKey);
            stripe
              .redirectToCheckout({
                sessionId: paymentSessionId,
              })
              .then((result) => {
                if (result.error) {
                  subscriber.error(result.error.message);
                } else {
                  subscriber.next(result);
                  subscriber.complete();
                }
              });
          },
          (err) => {
            subscriber.error(err);
          }
        );
    });
  }

}
